<template>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_10856_10247)">
        <path d="M10 17C13.866 17 17 13.866 17 10C17 6.13401 13.866 3 10 3C6.13401 3 3 6.13401 3 10C3 13.866 6.13401 17 10 17Z" :stroke="stroke" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M21 21L15 15" :stroke="stroke" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </g>
        <defs>
        <clipPath id="clip0_10856_10247">
        <rect width="24" height="24" fill="white"/>
        </clipPath>
        </defs>
    </svg>

</template>

<script>

export default {
  props: {
    stroke: {
      type: String,
      default: '#F2EFED',
    },
  },
}

</script>